import React from 'react'
import ModalPopup from 'britive-design-system/core/components/modal-popup'
import Typography from 'britive-design-system/core/components/typography'
import { ticketTypes } from 'components/ApprovalModal/constants'
import { classes } from '../constants'

const TicketDetails = ({
  onClose,
  translatedStrings,
  approvalsDetails,
  ticketDetails,
}) => {
  return (
    <ModalPopup
      width={500}
      title={
        <>
          <a
            href={approvalsDetails?.data?.context?.ticketUrl}
            target="_blank"
            rel="noreferrer"
          >
            {approvalsDetails?.data?.context?.ticketNumber}
          </a>
          &nbsp;Details
        </>
      }
      onCancel={onClose}
      buttons={[
        {
          text: 'Done',
          onClick: onClose,
          size: 'medium',
        },
      ]}
    >
      <Typography variant="label2">{translatedStrings.ticketType}</Typography>
      <div className={classes?.marginTop8}>
        <Typography variant="label1">
          {ticketTypes[approvalsDetails?.data?.context?.ticketType]}
        </Typography>
      </div>
      <br />
      <Typography variant="label2">{translatedStrings.ticketSummary}</Typography>
      <div className={classes?.marginTop8}>
        <Typography variant="label1">{ticketDetails?.title}</Typography>
      </div>
      <br />
      <Typography variant="label2">{translatedStrings.ticketAssignee}</Typography>
      <div className={classes?.marginTop8}>
        <Typography variant="label1">{ticketDetails?.assigneeName}</Typography>
      </div>
      <br />
      <Typography variant="label2">{translatedStrings.ticketSeverity}</Typography>
      <div className={classes?.marginTop8}>
        <Typography variant="label1">{ticketDetails?.severity || 'N/A'}</Typography>
      </div>
      <br />
      <Typography variant="label2">{translatedStrings.ticketStatus}</Typography>
      <div className={classes?.marginTop8}>
        <Typography variant="label1">{ticketDetails?.status}</Typography>
      </div>
    </ModalPopup>
  )
}

export default TicketDetails
